import {
  CSC_ADMIN_USER_ACTIVE_SESSION,
  CSC_ADMIN_USER_ACTIVE_SESSION_SUCCESS,
  CSC_ADMIN_USER_ACTIVE_SESSION_FAIL,
} from './actions';

const initialState = {
  loaded: false,
  data: {},
  extraData: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CSC_ADMIN_USER_ACTIVE_SESSION:
      return {
        ...state,
        loading: true,
      };
    case CSC_ADMIN_USER_ACTIVE_SESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result || {},
        error: null,
        extraData: 'This is extra info..........',
      };
    case CSC_ADMIN_USER_ACTIVE_SESSION_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
}
